import React , {useState , useEffect} from 'react'
import { BrowserRouter  ,Route ,Routes  } from 'react-router-dom'

import { GoogleOAuthProvider } from '@react-oauth/google';

//componets
import Login from './components/registrationForm/Login'
import SignUp from './components/registrationForm/Sign_up/SignUp'
import Forget_password from './components/registrationForm/Forget password/Forget_password'
import Email_verifiy_SignUp from './components/registrationForm/Sign_up/Email_verifiy'
import Email_verifiy_ForgetPassword from './components/registrationForm/Forget password/Email_verifiy'
import Home from './components/registrationForm/Home/Home'
import OTP from './components/registrationForm/OTP'



const App = ()=>{
  const clientId = "319499164212-cdbphahc6ak08du2bbjo3ma7f65up2cs.apps.googleusercontent.com";
  return (
       <GoogleOAuthProvider clientId={clientId}>
         <BrowserRouter >
              <Routes>
                <Route path='/' element={<Login/>}></Route>
                <Route path='/SignUp/:email' element={<SignUp/>}></Route>
                <Route path='/Forget_password/:email' element={<Forget_password/>}></Route>
                <Route path='/Email_verifiy/SignUp' element={<Email_verifiy_SignUp/>}></Route>
                <Route path='/Email_verifiy/ForgetPassword' element={<Email_verifiy_ForgetPassword/>}></Route>
                <Route path='/Home' element={<Home/>}></Route>
                <Route path='/OTP/:type/:email' element={<OTP/>}></Route>
              </Routes>
         </BrowserRouter>
       </GoogleOAuthProvider>
  )
}

export default App